import {
    UI_START_LOADING,
    UI_STOP_LOADING
} from "../types/uiTypes";


export const startLoading = () => ({
    type: UI_START_LOADING
})


export const stopLoading = () => ({
    type: UI_STOP_LOADING
})
